"use client";

import { useModal } from "@/contexts/ModalContext";

const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

type DownloadAppButtonProps = {
  className?: string;
  label?: string;
  showIcon?: boolean;
};

export function DownloadAppButton({
  className = "btn-gold",
  label = "Download The App",
  showIcon = true,
}: DownloadAppButtonProps) {
  const { openModal } = useModal();
  const classes = className.includes("cursor-pointer")
    ? className
    : `${className} cursor-pointer`.trim();

  return (
    <button type="button" className={classes} onClick={openModal}>
      {showIcon && <DownloadIcon />}
      {label}
    </button>
  );
}
